export interface Class {
  id: string;
  name: string;
  subject: string;
  studentsCount: number;
  teachersCount: number;
}

export const mockClasses: Class[] = [
  {
    id: '1',
    name: 'Klas 3A',
    subject: 'Wiskunde',
    studentsCount: 24,
    teachersCount: 2,
  },
  {
    id: '2',
    name: 'Klas 4B',
    subject: 'Nederlands',
    studentsCount: 28,
    teachersCount: 1,
  },
  {
    id: '3',
    name: 'Klas 5H',
    subject: 'Biologie',
    studentsCount: 22,
    teachersCount: 2,
  },
  {
    id: '4',
    name: 'Klas 6V',
    subject: 'Scheikunde',
    studentsCount: 18,
    teachersCount: 1,
  },
];
